// extracted by mini-css-extract-plugin
export default {"body":"styles_body__2FvBY","container":"styles_container__50lp-"};